// https://anyclip.atlassian.net/wiki/spaces/RD/pages/575537482/PCN+Tagging+Tool+-+User+roles+and+permissions

/**
 * Display name: Manage Content Owners
 * Description: Allows a user to manage Content Owners
 * If no permission: User unable create/update/delete Content Owners
 * @type {string}
 */

export const PCN_POST_NOTIFICATIONS = 'post/notifications';
export const PCN_GET_PARTNERS_ACCOUNTS = 'get/accounts';
export const PCN_GET_ADMIN = 'get/permissions';

export const PCN_GET_FEEDS = 'get/feeds';
export const PCN_GET_SELF_SERVE_SOURCES = 'get/self-serve-sources';

export const PCN_GET_CUSTOM_REPORTS = 'get/custom-reports';
export const PCN_POST_CUSTOM_REPORTS = 'port/custom-reports';
export const PCN_PUT_CUSTOM_REPORTS = 'put/custom-reports';
export const PCN_DELETE_CUSTOM_REPORTS = 'delete/custom-reports';

export const PCN_GET_USERS = 'get/users';
export const PCN_PUT_USERS = 'put/users';
export const PCN_POST_USERS = 'post/users';
export const PCN_DELETE_USERS = 'delete/users';

export const PCN_GET_ONLINE_HELP = 'get/online-help';
export const PCN_PUT_ONLINE_HELP = 'put/online-help';
export const PCN_POST_ONLINE_HELP = 'post/online-help';
export const PCN_DELETE_ONLINE_HELP = 'delete/online-help';

export const PCN_GET_PUBLISHER = 'get/publisher';
export const PCN_POST_PUBLISHER = 'post/publisher';
export const PCN_PUT_PUBLISHER = 'put/publisher';
export const PCN_GET_ADVERTISERS = 'get/advertisers';

export const PCN_GET_PLAYER = 'get/player';
export const PCN_GET_INVENTORY = 'get/inventory';
export const PCN_GET_ANALYTICS = 'get/analytics';
export const PCN_GET_PEOPLE = 'get/people';
export const PCN_GET_ENTITIES = 'get/entities';

export const PCN_GET_LIVE_EVENTS = 'get/live-event';
export const PCN_POST_LIVE_EVENTS = 'post/live-event';
export const PCN_PUT_LIVE_EVENTS = 'put/live-event';
export const PCN_DELETE_LIVE_EVENTS = 'delete/live-event';

export const PCN_GET_PLAYER_NEW = 'get/player-new';
export const PCN_POST_PLAYER_NEW = 'post/player-new';
export const PCN_PUT_PLAYER_NEW = 'put/player-new';
export const PCN_DELETE_PLAYER_NEW = 'delete/player-new';

export const PCN_GET_DESTINATIONS = 'get/publish-destinations';
export const PCN_PUT_DESTINATIONS = 'put/publish-destinations';
export const PCN_POST_DESTINATIONS = 'post/publish-destinations';
export const PCN_DELETE_DESTINATION = 'delete/publish-destinations';

export const PCN_INVITATIONS_SHOW_TABLE = 'invitations-show-table';
export const PCN_GET_INVITATIONS = 'get/invitations';
export const PCN_GET_X_RAY_CAMPAIGNS = 'get/x-ray';
export const PCN_GET_X_RAY_CREATIVES = 'get/x-ray';
export const PCN_GET_X_RAY_LINE_ITEMS = 'get/x-ray';
export const PCN_GET_RESTORE = 'get/restore';
export const PCN_GET_DOMAIN = 'get/domain';
export const PCN_GET_MARKETPLACE_DASHBOARD = 'get/marketplace';
export const PCN_GET_MARKETPLACE_SELF_SERVE = 'get/marketplace-self-serve';

export const PCN_GET_FORMS_EDITOR = 'get/forms';
export const PCN_POST_FORMS_EDITOR = 'post/forms';
export const PCN_PUT_FORMS_EDITOR = 'put/forms';
export const PCN_DELETE_FORMS_EDITOR = 'delete/forms';

export const PCN_FORMS_GET_REPORT = 'get/formReportRequests';

export const PCN_GET_MANAGE_WATCH = 'get/watch';
export const PCN_POST_MANAGE_WATCH = 'post/watch';
export const PCN_PUT_MANAGE_WATCH = 'put/watch';
export const PCN_DELETE_MANAGE_WATCH = 'delete/watch';

export const PCN_GET_HOSTED_WATCH = 'get/hosted-watch';
export const PCN_POST_HOSTED_WATCH = 'post/hosted-watch';
export const PCN_PUT_HOSTED_WATCH = 'put/hosted-watch';
export const PCN_DELETE_HOSTED_WATCH = 'delete/hosted-watch';

export const PCN_HOSTED_WATCH_SHOW_HUB_SELECTOR = 'hosted-watch-show-hub-selector';
export const PCN_HOSTED_WATCH_SHOW_WATCHES = 'hosted-watch-show-watches';
export const PCN_HOSTED_WATCH_SHOW_MY_WATCH = 'hosted-watch-show-my-watch';
export const PCN_HOSTED_WATCH_SHOW_SHARED_WITH_YOU = 'hosted-watch-show-shared-with-you';

export const MANAGE_CONTENT_OWNERS = 'get/content-owners';

// analytics
export const ANALYTICS_VIDEO_CONTENT_PERFORMANCE = 'analytics-video-external';
export const ANALYTICS_LIVE_EVENTS_DASHBOARD = 'analytics-live-events';
export const ANALYTICS_MONETIZATION_DASHBOARD = 'analytics-monetization';
export const ANALYTICS_CUSTOM_REPORTS = 'analytics-custom-reports';
export const ANALYTICS_SHOW_ACCOUNT = 'analytics-show-account';

// rules settings
export const GET_PERSONAL_SETTING = 'get/personal-settings';
export const POST_PERSONAL_SETTING = 'post/personal-settings';
export const PUT_PERSONAL_SETTING = 'put/personal-settings';
export const DELETE_PERSONAL_SETTING = 'delete/personal-settings';

export const SSO_PAGE = 'get/sso';

export const GET_FORM_TEMPLATES = 'get/form-templates';
export const POST_FORM_TEMPLATES = 'post/form-templates';
export const PUT_FORM_TEMPLATES = 'put/form-templates';
export const DELETE_FORM_TEMPLATES = 'delete/form-templates';

export const WATCH_CONFIGURATION_CUSTOM_SETTING = 'watch-custom-settings';
export const WATCH_EDIT_MY_WATCH = 'watch-edit-my-watch';

export const VIEW_ROLES_PERMISSIONS = 'get/roles-permissions';

export const PCN_GET_PLAYLIST = 'get/editorial';
export const PCN_POST_PLAYLIST = 'post/editorial';
export const PCN_PUT_PLAYLIST = 'put/editorial';
export const PCN_DELETE_PLAYLIST = 'delete/editorial';

export const PCN_GET_LUMINOUS_CONFIG = 'anyclip-config-luminous-config';

export const ACCOUNT_BULK_DELETE_VIDEOS = 'account-bulk-delete-videos';

// Video permissions
export const PCN_GET_VIDEO = 'get/video';
export const PCN_POST_VIDEO = 'post/video';
export const PCN_PUT_VIDEO = 'put/video';
export const VIDEO_ADMIN = 'video-admin';
export const VIDEO_VERSION_UPLOAD = 'video-version-upload';
export const VIDEO_ACCESS_TARGETING = 'video-access-targeting';
export const VIDEO_EDIT_SOURCE = 'video-edit-source';
export const VIDEO_SHOW_CONTENT_OWNER_NAME = 'video-show-source-content-owner-name';
export const VIDEO_ALL_TAB = 'video-all-tab';
export const VIDEO_MY_TAB = 'video-my-tab';
export const VIDEO_SHARED_TAB = 'video-shared-tab';

export const VIDEO_FILTERS_ACCOUNT = 'video-filters-account';
export const VIDEO_FILTERS_STATUS = 'video-filters-status';
export const VIDEO_FILTERS_MEDIA_TYPE = 'video-filters-media-type';
export const VIDEO_FILTERS_HUBS = 'video-filters-hubs';
export const VIDEO_FILTERS_SOURCE = 'video-filters-source';
export const VIDEO_FILTERS_VERIFICATION = 'video-filters-verification';
export const VIDEO_FILTERS_FEED_TYPE = 'video-filters-feed-type';
export const VIDEO_FILTERS_PEOPLE = 'video-filters-people';
export const VIDEO_FILTERS_BRANDS = 'video-filters-brands';
export const VIDEO_FILTERS_LANGUAGES = 'video-filters-languages';
export const VIDEO_FILTERS_CUSTOM_TAGS = 'video-filters-custom-tags';
export const VIDEO_FILTERS_PUBLISH_STATUS = 'video-filters-publish-status';
export const VIDEO_FILTERS_PUBLISH_PLATFORM = 'video-filters-publish-platform';
export const VIDEO_FILTERS_TARGETING_STATUS = 'video-filters-targeting-status';
export const VIDEO_FILTERS_CATEGORIES = 'video-filters-categories';
export const VIDEO_FILTERS_UPLOAD_DATE = 'video-filters-upload-date';
export const VIDEO_FILTERS_BRAND_SAFETY = 'video-filters-brand-safety';
export const VIDEO_FILTERS_KEYWORDS = 'video-filters-keywords';
export const VIDEO_FILTERS_EVERGREEN = 'video-filters-evergreen';
export const VIDEO_FILTERS_SPONSORED = 'video-filters-sponsored';

export const VIDEO_INSIGHTS = 'video-view-insights';
export const VIDEO_EMBED = 'video-embed';
export const VIDEO_INFO_TAB = 'video-info-tab';
export const VIDEO_ADVANCED_TAB = 'video-advanced-tab';
export const VIDEO_SLIDES = 'video-slides';
export const VIDEO_SEARCH_CONTENT_OWNERS = 'video-search-content-owners';
export const VIDEO_SCREEN_RECORDING = 'video-screen-webcam-recording';
export const VIDEO_TAG_INFO = 'video-tag-info';
export const VIDEO_DOWNLOAD_SOURCE_TAGS = 'video-download-source-tags';
export const USERS_GENERATE_USER_TOKEN = 'user-generate-token';
export const VIDEO_SPONSORED_CONTENT = 'video-sponsored-content';

// Self Service Player permissions
export const SELF_SERV_PLAYER_ACCESS_MONETIZATION = 'self-serve-player-access-monetization';
